import type {GuidedApiCallParams, GuidedItemsV2} from '../models/models';
import {makeLogger} from '../../../logger/logger';


import type {GuidedMiddleware} from '../models/middleware';
import {GuidedHistoryLinkDetails, GuidedQuickLinkDetails} from '../models/quick-link';
import {extractTealiumId, getCookieValue} from '../../../utils/helpers/cookie-manager';
import axios from 'axios';

const {
  info,
  // debug,
  warn,
  // err
} = makeLogger({
  pathToCurrentFile: 'components/guided2/middlewares/historyOfSearches.ts',
});

function getTealiumId(){
    const tealiumHeader = {};
    const tealiumValue = extractTealiumId(getCookieValue('TEAL'));
    if(tealiumValue){
      tealiumHeader['X-TEAL-User'] = tealiumValue;
    }
    return tealiumHeader;
}

const historyOfSearches: GuidedMiddleware = async (params: GuidedApiCallParams, next) => {
    const tealium = getTealiumId();

    const result: GuidedItemsV2 = await next({
      ...params,
      guidedRequest: {
        ...params.guidedRequest,
        auth: {
          ...params.guidedRequest.auth,
          ...tealium,
        },
        customHeaders: {
          ...params.guidedRequest.customHeaders,
          'bypass-cache': 'true',
        },
      },
    });

    return result.map((item) => {

        (item.details as GuidedHistoryLinkDetails).deletionCallback = async () => {
            try {
              const deletionApiEndpoint = params.guidedRequest.apiEndpoint.replace('suggestions', 'personalizations');

              const response = await axios.post(
                deletionApiEndpoint,
                {
                  searcher: 'se/all',
                  term: item.details.quickLinkTitle,
                  context: params.guidedRequest.context,
                  action: {
                    type: 'history/delete',
                  },
                },
                {
                  headers: {
                    ...params.guidedRequest.auth,
                    ...tealium,
                    'Content-Type': 'application/json',
                    'Bypass-Cache': 'true',
                  },
                }
              );

              if (response.status !== 200) {
                warn('Guided History backend response error:', response);
                return;
              }

              if (params.dataflux?.root?.results) {
                params.dataflux.root.results = params.dataflux.root.results.filter(
                  (qi) => qi.details.quickLinkTitle !== item.details.quickLinkTitle
                );
              }
            } catch (error) {
              warn('Error during history deletion:', error);
            }
        };

        return item;
    });
};

export default historyOfSearches;